import { useLocation } from 'react-router-dom';

import { paths } from '@/routing';
import { buildPath } from '@/utils/buildPath';

/** Returns plot-related paths for the current route context (staff vs. landsteward). */
export const usePlotPaths = () => {
  const { pathname } = useLocation();
  const isStaff = pathname.startsWith('/staff');

  return {
    plots: isStaff ? buildPath(paths.staff.plots) : buildPath(paths.landSteward.plots),
    plotUpload: isStaff ? buildPath(paths.staff.plotUpload) : buildPath(paths.landSteward.plotUpload),
    coordinateUpload: isStaff
      ? buildPath(paths.staff.plotCoordinateUpload)
      : buildPath(paths.landSteward.plotCoordinateUpload),
  };
};
